__turbopack_context__.v({
  "closeButton": "aircraftIncidentModal-module-scss-module__NvK0mq__closeButton",
  "logoContainer": "aircraftIncidentModal-module-scss-module__NvK0mq__logoContainer",
  "message": "aircraftIncidentModal-module-scss-module__NvK0mq__message",
  "modalContent": "aircraftIncidentModal-module-scss-module__NvK0mq__modalContent",
  "modalOverlay": "aircraftIncidentModal-module-scss-module__NvK0mq__modalOverlay",
  "title": "aircraftIncidentModal-module-scss-module__NvK0mq__title",
});
